module.exports = __webpack_public_path__ + "static/images/logo-dark.a4916b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Themes/Allstate/logo-dark.jpg
// module id = xY7D
// module chunks = 12